/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// ===== START: Scooch custom JS (Claude/Codex) — NOT part of stock Focal custom.js =====
// Everything below to the matching END marker is Scooch-added. Ported from live 12.7.1.
// Agent START: Codex streamlined how-to guide runtime (2026-08-07)
(function () {
  'use strict';

  var titles = {
    '/pages/wingman-info': 'Wingman',
    '/pages/wingmate-info': 'Wingmate',
    '/pages/moneymate-info': 'Moneymate',
    '/pages/halocase-info': 'MagCase & HaloCase',
    '/pages/magcase-info': 'MagCase',
    '/pages/scooch-glass-info': 'Screen Protectors',
    '/pages/juicebank-pro-info': 'JuiceBank Pro',
    '/pages/juicebank-go-info': 'JuiceBank Go',
    '/pages/juicedock-info': 'JuiceDock',
    '/pages/juicepuck-info': 'JuicePuck',
    '/pages/juiceplug-info': 'JuicePlug',
    '/pages/juicecord-4-in-1-info': 'JuiceCord 4-in-1',
    '/pages/juicecord-6-in-1-info': 'JuiceCord 6-in-1',
    '/pages/juicecord-c-info': 'JuiceCord C',
    '/pages/wingmount-info': 'Wingmount',
    '/pages/magmount-info': 'MagMount',
    '/pages/magmount-flat-info': 'MagMount Flat',
    '/pages/wingmount-card-info': 'Wingmount Card',
    '/pages/wingback-info': 'Wingback',
    '/pages/magring-info': 'MagRing 2.0',
    '/pages/magwallet-info': 'MagWallet 2.0',
    '/pages/magstar-info': 'MagStar',
    '/pages/bandmate-info': 'BandMate',
    '/pages/carrykit-info': 'CarryKit', // Codex 2026-06-29: include CarryKit in guide-page cleanup map
    '/pages/replacement-clickstand-info': 'Replacement Clickstand',
    '/pages/tech-spray-info': 'Tech Spray',
    '/pages/tech-cleaning-kit-info': 'Tech Cleaning Kit',
    '/pages/tech-wipes-info': 'Tech Wipes',
    '/pages/car-wipes-info': 'Car Wipes'
  };
  var portraitVideos = {
    'xoSAmrJwaqw': true,
    '_RzDxSOGYL4': true
  };
  var youtubeWarmed = false;

  function isGuidePage() {
    return !!titles[window.location.pathname.replace(/\/$/, '')];
  }

  function addGuideStyles() {
    if (document.getElementById('scooch-guide-runtime-styles')) return;
    var style = document.createElement('style');
    style.id = 'scooch-guide-runtime-styles';
    style.textContent = [
      '.scooch-guide-page-active #omnisend-forms-wrapper,.scooch-guide-page-active #omnisend-forms-container,.scooch-guide-page-active [id^="omnisend-form-"],.scooch-guide-page-active [class*="omnisend-form-"][role="dialog"],.scooch-guide-page-active [class*="omnisend-reset-"][role="dialog"]{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      '.scooch-guide-has-inner-title .shopify-section--main-page .page-header{display:none!important}',
      '.scooch-guide-page-active:not(.scooch-guide-has-inner-title) .shopify-section--main-page .page-header__text-wrapper{margin:clamp(26px,4vw,44px) auto!important}',
      '.scooch-guide-back{display:inline-flex;align-items:center;min-height:38px;margin:0 0 18px;padding:0 13px;border:1px solid #ded5cc;border-radius:8px;background:#f7f4f0;color:#3a3028!important;font-size:13px;font-weight:800;text-decoration:none!important}',
      '.scooch-guide-page-active .scooch-guide-v2 :is(.wm-checklist,.jb-checklist,.mg-checklist,.mr-checklist,.mw-checklist,.ms-checklist,.bm-checklist){display:block!important;margin:0!important;padding-left:20px!important;list-style:disc!important}',
      '.scooch-guide-page-active .scooch-guide-v2 :is(.wm-checklist,.jb-checklist,.mg-checklist,.mr-checklist,.mw-checklist,.ms-checklist,.bm-checklist) li{position:static!important;margin:7px 0 0!important;padding-left:0!important;list-style:disc!important}',
      '.scooch-guide-page-active .scooch-guide-v2 :is(.wm-checklist,.jb-checklist,.mg-checklist,.mr-checklist,.mw-checklist,.ms-checklist,.bm-checklist) li:before{display:none!important;content:none!important}',
      '.scooch-guide-v2 .scooch-yt-facade{cursor:pointer;position:relative!important;background:#111!important;overflow:hidden}',
      '.scooch-guide-v2 .scooch-yt-facade>img{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;border-radius:inherit!important;transform:scale(1.02)!important}',
      '.scooch-guide-v2 .scooch-yt-facade--short{max-width:420px!important;aspect-ratio:9/16!important}',
      '.scooch-guide-v2 .scooch-yt-play{position:absolute!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important;background:none!important;border:0!important;cursor:pointer!important;padding:0!important;opacity:.92!important;transition:opacity .2s ease,transform .2s ease!important;z-index:2!important}',
      '.scooch-guide-v2 .scooch-yt-facade:hover .scooch-yt-play{opacity:1!important;transform:translate(-50%,-50%) scale(1.08)!important}',
      '.scooch-guide-v2 .scooch-yt-loading{position:absolute;inset:0;z-index:4;display:grid;place-content:center;justify-items:center;gap:10px;background:rgba(12,12,12,.78);color:#fff;font-size:13px;font-weight:750;text-align:center}',
      '.scooch-guide-v2 .scooch-yt-spinner{width:30px;height:30px;border:3px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:scoochGuideSpin .7s linear infinite}',
      '.scooch-guide-v2 .scooch-yt-slow-link{color:#fff!important;text-decoration:underline!important}',
      '@keyframes scoochGuideSpin{to{transform:rotate(360deg)}}',
      '@media(prefers-reduced-motion:reduce){.scooch-guide-v2 .scooch-yt-spinner{animation-duration:1.4s}}'
    ].join('');
    document.head.appendChild(style);
  }

  function warmYouTube() {
    if (youtubeWarmed) return;
    youtubeWarmed = true;
    ['https://www.youtube-nocookie.com', 'https://i.ytimg.com'].forEach(function (href) {
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  function buildPlayButton(title) {
    var button = document.createElement('button');
    button.className = 'scooch-yt-play';
    button.type = 'button';
    button.setAttribute('aria-label', 'Play ' + title);
    button.innerHTML = '<svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true" focusable="false"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.63-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24 27 14v20" fill="white"/></svg>';
    return button;
  }

  function createFacade(videoId, title, className) {
    var facade = document.createElement('div');
    facade.className = (className || 'youtube-container') + ' scooch-yt-facade';
    if (portraitVideos[videoId]) facade.className += ' scooch-yt-facade--short';
    facade.dataset.videoid = videoId;
    facade.dataset.videoTitle = title;
    facade.tabIndex = -1;

    var image = document.createElement('img');
    image.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/hqdefault.jpg';
    image.alt = title;
    image.loading = 'lazy';
    image.decoding = 'async';
    facade.appendChild(image);
    facade.appendChild(buildPlayButton(title));
    return facade;
  }

  function convertLegacyFrames(root, pageTitle) {
    root.querySelectorAll('iframe[src*="youtube"][src*="/embed/"]').forEach(function (frame) {
      var wrap = frame.closest('.youtube-container');
      if (!wrap || wrap.classList.contains('scooch-yt-facade')) return;
      var idMatch = frame.src.match(/\/embed\/([A-Za-z0-9_-]+)/);
      if (!idMatch) return;
      wrap.replaceWith(createFacade(idMatch[1], frame.title || pageTitle + ' how-to video', wrap.className));
    });
  }

  function activateFacade(facade) {
    if (!facade || facade.dataset.activated || facade.querySelector('iframe')) return;
    var videoId = facade.dataset.videoid;
    if (!videoId) return;
    facade.dataset.activated = 'true';
    facade.setAttribute('aria-busy', 'true');
    warmYouTube();

    var loading = document.createElement('div');
    loading.className = 'scooch-yt-loading';
    loading.setAttribute('role', 'status');
    loading.innerHTML = '<span class="scooch-yt-spinner" aria-hidden="true"></span><span>Loading video…</span>';
    facade.appendChild(loading);

    var iframe = document.createElement('iframe');
    var startedAt = Date.now();
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&playsinline=1&rel=0';
    iframe.title = facade.dataset.videoTitle || 'Scooch how-to video';
    iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;z-index:3;border-radius:inherit;';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.addEventListener('load', function () {
      window.setTimeout(function () {
        facade.removeAttribute('aria-busy');
        loading.remove();
      }, Math.max(0, 500 - (Date.now() - startedAt)));
    }, { once: true });
    facade.appendChild(iframe);

    window.setTimeout(function () {
      if (!facade.hasAttribute('aria-busy') || loading.querySelector('.scooch-yt-slow-link')) return;
      var link = document.createElement('a');
      link.className = 'scooch-yt-slow-link';
      link.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(videoId);
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Taking a while? Watch on YouTube';
      loading.appendChild(link);
    }, 9000);
  }

  function addGuideBackLink(root) {
    if (root.querySelector(':scope > .scooch-guide-back')) return;
    var back = document.createElement('a');
    back.className = 'scooch-guide-back';
    back.href = '/pages/howto';
    back.textContent = '← All Guides';
    root.insertBefore(back, root.firstChild);
  }

  function updateGuideBreadcrumb(pageTitle) {
    var breadcrumb = document.querySelector('.breadcrumb__list');
    if (!breadcrumb) return;
    var firstLink = breadcrumb.querySelector('a');
    if (firstLink) {
      firstLink.href = '/pages/howto';
      firstLink.textContent = 'All Guides';
    }
    var current = breadcrumb.querySelector('[aria-current="page"]');
    if (current) current.textContent = pageTitle;
  }

  function removeLegacyGuidePrompts(root) {
    root.querySelectorAll('.sg-note').forEach(function (note) {
      if (/need a different guide/i.test(note.textContent)) note.remove();
    });
  }

  function findGuideRoot() {
    var root = document.querySelector('.scooch-guide-v2');
    if (root) return root;
    var guide = document.querySelector('.scooch-guide-page, .video-page, .wingmate-guide, .juicebank-guide, .wingmount-guide, .magmount-guide, .wingback-guide, .magring-guide, .magwallet-guide, .magstar-guide, .bandmate-guide');
    if (guide && guide.parentNode && guide.parentNode.classList.contains('rte')) {
      guide.parentNode.classList.add('scooch-guide-v2');
      return guide.parentNode;
    }
    return null;
  }

  function initGuidePage() {
    if (!isGuidePage() || document.body.dataset.scoochGuideReady === 'true') return;
    document.body.dataset.scoochGuideReady = 'true';
    document.body.classList.add('scooch-guide-page-active');
    addGuideStyles();
    var pageTitle = titles[window.location.pathname.replace(/\/$/, '')];

    document.querySelectorAll('.page-header h1, .breadcrumb__link[aria-current="page"]').forEach(function (node) {
      if (node.textContent.trim() !== pageTitle) node.textContent = pageTitle;
    });
    updateGuideBreadcrumb(pageTitle);

    var root = findGuideRoot();
    if (!root) return;
    convertLegacyFrames(root, pageTitle);
    if (root.querySelector('h1')) document.body.classList.add('scooch-guide-has-inner-title');
    removeLegacyGuidePrompts(root);
    addGuideBackLink(root);
    if (root.querySelector('.scooch-yt-facade')) warmYouTube();

    document.addEventListener('click', function (event) {
      var facade = event.target.closest('.scooch-yt-facade');
      if (facade && root.contains(facade)) activateFacade(facade);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuidePage, { once: true });
  } else {
    initGuidePage();
  }
})();
// Agent END: Codex streamlined how-to guide runtime (2026-08-07)

// Agent START: Claude deferred homepage carousels (2026-10-31)
(function () {
  var slots = document.querySelectorAll('[data-scooch-deferred-section]');
  if (!slots.length) return;

  var pending = {};
  Array.prototype.forEach.call(slots, function (slot) {
    var id = slot.getAttribute('data-scooch-deferred-section');
    var section = document.getElementById('shopify-section-' + id);
    if (section) pending[id] = section;
  });

  function loadSection(id, attempt) {
    var section = pending[id];
    if (!section) return;
    delete pending[id];

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) {
        var fresh = new DOMParser().parseFromString(data[id] || '', 'text/html').getElementById('shopify-section-' + id);
        if (!fresh || fresh.querySelector('[data-scooch-deferred-section]')) throw new Error('empty');
        section.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        if (attempt < 2) {
          pending[id] = section;
          setTimeout(function () { loadSection(id, attempt + 1); }, 1500);
        }
      });
  }

  if (!('IntersectionObserver' in window)) {
    Object.keys(pending).forEach(function (id) { loadSection(id, 1); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      loadSection(entry.target.id.replace('shopify-section-', ''), 1);
    });
  }, { rootMargin: '1200px 0px' });

  Object.keys(pending).forEach(function (id) { observer.observe(pending[id]); });
})();
// Agent END: Claude deferred homepage carousels (2026-10-31)

// ===== END: Scooch custom JS (Claude/Codex) =====
